export enum EmailTemplateDetailsTabTypes {
    GENERAL_INFO = "generalInfo",
    CONTENT = "content"
}